import { TaskTemplateStep } from "Models/Tasks/TaskTemplateStep";
import { TaskTemplateTag } from "Models/Tasks/TaskTemplateTag";

export class AuditItemTemplate {
    public id?: number;
    public name: string;
    public pictureUrl?: string;
    public descriptionFileUrl?: string;
    public description: string;
    public type: string = "audit";
    public positionIndex: number;
    public createdAt: Date;
    public lastUpdatedAt: Date;
    public videoUrl?: string;
    public videoThumbnailUrl?: string;

    public pictureFile?: File;
    public videoFile?: File;
    public videoThumbnailFile?: File;
    public descriptionFile?: File;
    
    public steps: TaskTemplateStep[] = [];
    public taskTemplateTags: TaskTemplateTag[] = [];
    public weight: number = 1;
}


// WEBPACK FOOTER //
// ./src/Models/Audit/AuditItemTemplate.ts